export default __webpack_public_path__ + "a2edea2deafbd4108ce999db1cdfbf0f.gif";